module.exports = __webpack_public_path__ + "img/vertical_7_1_7016.c49afda0.png";